export const oneHourInMinutes = 60;
